
var data,
  userStatus,
  voteStatus,
  panelShown = 0,
  form = {},
  votingOver = true;


var utils = (function () {
  var runTemplate = function (template, target, context) {
    var source = $(template).html();
    var compile = Handlebars.compile(source);
    var data = { array: context };
    $(target).html(compile(data));
    if (votingOver) {
      var votingBlockExists = setInterval(function () {
        if ($('.hide-when-over').length) {
          clearInterval(votingBlockExists);
          $('.hide-when-over').css('visibility', 'hidden');
        }
      }, 100);
    }
  };

  var getCurrentGirl = function (id, data) {
    var currentGirl = "";
    data.filter(function (index) {
      if (index.id == id) {
        currentGirl = index;
      }
    });
    return currentGirl;
  };

  var getUserStatus = function() {
    var status;
    var params = window.location.search;
    var girl = utils.getGirlFromHash();
    if (girl && girl != "" && params != "") {
      params += "&girl_id=" + girl;
    }

    $.ajax({
      url: "/pageantvote/api/check.php" + params,
      type: "GET"
    })
      .done(function(response) {
        status = response.status;
        userStatus = status;
        if (status == "no user") {
          window.location.href = "/pageantvote/register.php" + params;
        }
      })
      .fail(function(response) {
        status = "failed";
        userStatus = status;
      });
  };

  var getParameterByName = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  var getGirlFromHash = function () {
    var state = getParameterByName("state");
    var hash = window.location.hash.substring(1);
    var girlId = state || hash;
    return parseInt(girlId.split("-", 1));
  };

  var updateViewButton = function () {
    //on click of 'view & vote' button
    $(".hg-single").on("click", function (e) {
      $(".vote-now", this).trigger("click");
    });
    $(".vote-now").on("click", function (e) {
      e.stopPropagation();

      //remove states from existing panels and tiles
      $(".hg-single").removeClass("open");
      $(".hg-panel").remove();

      //set the current tile and ID
      var parentTile = $($(this).parents(".hg-single")[0]);
      var currentID = parentTile.data("girl-id");

      // Retrieve index of current tile
      var currentTileIndex = parentTile.index() + 1;

      //add an open class to the current tile
      parentTile.addClass("open");

      //set which tiles are 4th and last
      var last = $(".hg-single").last(); // Very last .hg-single
      var position = "";

      //create the handlebars template from the global data
      var source = $("#hg-panel").html();
      var compile = Handlebars.compile(source);
      var context = utils.getCurrentGirl(currentID, data);
      var panel = compile(context);

      //determine which tile to add the panel after

      width = window.innerWidth || document.body.clientWidth;
      if (width <= 1024) {
        // Mobile
        currentRow = Math.ceil(currentTileIndex / 2);
        position = currentRow * 2 - 1;
      } else {
        currentRow = Math.ceil(currentTileIndex / 4);
        position = currentRow * 4 - 1;
      }

      //add the created panel in the correct location
      if ($(".hg-single").eq(position).length > 0) {
        $(".hg-single")
          .eq(position)
          .after(panel);
      } else {
        last.after(panel);
      }

      //get the panel that just opened
      var openedPanel = $('.hg-panel[data-girl-id="' + currentID + '"]');

      if (typeof voteStatus !== "undefined" && userStatus === true) {
        if (voteStatus.total == 69 && panelShown === 0) {
          $(".panel-share h3").show();
          panelShown = 1;
        }
        if (voteStatus.today) {
          $(".vote-info").show();
          $(".vote-info b").text(voteStatus.today);
        } else {
          $(".vote-info").show();
          $(".vote-info b").text(0);
          $(".votes-left-wrapper").show();
        }
      } else {
        $(".vote-info").hide();
      }

      if ((voteStatus.today && voteStatus.today === 0) || (userStatus === true && !voteStatus.today)) {
        $(".vote-button").attr("disabled", "disabled");
        $(".vote-button").attr('style', 'pointer-events:none;')
        $("[href='#vote-section']").attr("disabled", "disabled");
        $("[href='#vote-section']").attr('style', 'pointer-events:none;')
        $("#noVotesLeft").html('Votes Remaining Today: 0')
      }

      scroll_to(parentTile);

      //set listener on the recently opened panel
      $(".hg-panel-close").on("click", function () {
        $(this)
          .parents(".hg-panel")
          .remove();
        parentTile.removeClass("open");

        window.location.hash = "!";
      });

      //set action based on userStatus
      $(".vote-button").on("click", function (e) {
        e.preventDefault();
        var girl_id = $(this).data("girl-id");

        $.ajax({
          url: "/pageantvote/api/vote.php",
          type: "GET",
          data: { girl_id: girl_id }
        })
          .done(function (response) {
            voteStatus = response;
            if (response.error) {
              $(".vote-button").attr("disabled", "disabled");
              $(".vote-info b").text("0");
              $(".votes-left-wrapper").hide();
              $(".vote-number").text("0");
            } else {
              $(".vote-info b").text(response.today);
              $(".vote-info").show();
              $(".votes-left-wrapper").show();
              $(".vote-number").text(voteStatus.today);
              $(".panel-share h3").hide(150);
              $(".panel-share h3").show(150);
              ga("send", "event", "Vote", "Click");
            }
            if (response.today === 0) {
              $(".vote-button").attr("disabled", "disabled");
            }
          })
          .fail(function () {
            console.warn("error");
          });
      });

      if (votingOver) {
        var votingBlockExists = setInterval(function () {
          if ($('.hide-when-over').length) {
            clearInterval(votingBlockExists);
            $('.hide-when-over').css('visibility', 'hidden');
          }
        }, 100);
      }
    });
  };

  var getAllParams = function (search_string) {
    var parse = function (params, pairs) {
      var pair = pairs[0];
      var parts = pair.split("=");
      var key = decodeURIComponent(parts[0]);
      var value = decodeURIComponent(parts.slice(1).join("="));
      if (typeof params[key] === "undefined") {
        params[key] = value;
      } else {
        params[key] = [].concat(params[key], value);
      }
      return pairs.length == 1 ? params : parse(params, pairs.slice(1));
    };
    return typeof search_string !== undefined
      ? {}
      : parse({}, search_string.substr(1).split("&"));
  };

  // var vote = function(girl) {
  //   return status;
  // };

  var updateLoadMore = function (reset) {
    if (!reset) {
      reset = false;
    }

    var girls;
    $(".load-more").hide();

    girls = $(".hg-single");
    if (girls.length > 20) {
      $(".load-more").show();
    }

    if (reset === true) {
      $(".hg-single").hide();
      paginateGirls();
    }
  };

  var paginateGirls = function (scrollTo) {
    var girls, page;

    girls = $(".hg-single").filter(function () {
      return $(this).css("display") == "none";
    });

    if (girls.length) {
      page = girls.splice(0, 20);
      $.each(page, function () {
        $(this).show();
      });
    }

    if (!girls.length) {
      $(".load-more").hide();
    }

    $('html, body').animate({ scrollTop: (scrollTo - 450) }, 0);
  };

  var getVoteStatus = function() {
    $.ajax({
      url: "/pageantvote/api/vote.php",
      type: "GET"
    })
      .done(function(response) {
        voteStatus = response;
      })
      .fail(function() {
        console.warn("error");
      });
  };

  return {
    getAllParams: getAllParams,
    getCurrentGirl: getCurrentGirl,
    getGirlFromHash: getGirlFromHash,
    getParameterByName: getParameterByName,
    // getRegions: getRegions,
    getUserStatus: getUserStatus,
    getVoteStatus: getVoteStatus,
    paginateGirls: paginateGirls,
    updateLoadMore: updateLoadMore,
    updateViewButton: updateViewButton,
    runTemplate: runTemplate
  };
})();

var homePage = function () {
  // counter.startTimer();
  var $countdownEl = $(".js-countdown");
  $.ajax({
    url: "/pageantvote/api/vote.php",
    type: "GET"
  })
    .done(function(response) {
      const { today } = response
      if ((today === 0)) {
        $(".vote-button").attr("disabled", "disabled");
        $(".vote-button").attr('style', 'pointer-events:none;')
        $("[href='#vote-section']").attr("disabled", "disabled");
        $("[href='#vote-section']").attr('style', 'pointer-events:none;')
        $("#noVotesLeft").html('Votes Remaining Today: 0')
      }
    })
    .fail(function() {
      console.warn("error");
    });
  votingOver = false;
  // Uncomment these two lines when voting is over.  This will hide voting functionality.
  // $('.hide-when-over').remove();
  // $('.show-when-over').show();
  if ($countdownEl.length > 0) {
    var eventTime = moment('2022-04-23T23:59:59').unix();
    var currentTime = moment().unix();
    console.log('current', currentTime)
    console.log('event Time', eventTime)
    var diffTime = eventTime - currentTime;
    var duration = moment.duration(diffTime * 1000, "milliseconds");
    var interval = 1000;

    console.log('duration in seconds', duration.days(), duration.hours(), duration.minutes(), duration.seconds())
    // if time to countdown
    if (diffTime > 0) {
      var $days = $countdownEl.find(".js-countdown--days .js-countdown__int");
      var $hours = $countdownEl.find(".js-countdown--hours .js-countdown__int");
      var $mins = $countdownEl.find(".js-countdown--mins .js-countdown__int");
      var $secs = $countdownEl.find(".js-countdown--secs .js-countdown__int");

      setInterval(function() {
        duration = moment.duration(
          duration.asMilliseconds() - interval,
          "milliseconds"
        );

        // show how many days, hours, minutes and seconds are left
        $days.html(duration.days());
        $hours.html(duration.hours());
        $mins.html(duration.minutes());
        $secs.html(duration.seconds());
      }, interval);
    } else {
      votingOver = true;
      $('.hide-when-over').remove();
      $('.show-when-over').show();


    }
  }


  // Commented out API Status checks
  utils.getUserStatus();
  utils.getVoteStatus();

  window.addEventListener('hashchange', function () {
    sessionStorage.setItem('hash', window.location.hash);
  }, false);


  getGirls()
  //Sort HGs by First Name via Select
  $("#hg-select").on("change", function () {
    var optionVal = $(this)[0].value;

    let girlsApiResponse = document.getElementById("hgApiResponse");
    if (girlsApiResponse.dataset.girls && JSON.parse(girlsApiResponse.dataset.girls)) {
      filterGirls(JSON.parse(girlsApiResponse.dataset.girls), optionVal)
    } else {
      getGirls();
      filterGirls(JSON.parse(girlsApiResponse.dataset.girls), optionVal)
    }

  });
};

//Retrieve girls from the server and store them in the DOM for later filtering.
function getGirls() {
  var query = utils.getGirlFromHash()
    ? { girl_id: utils.getGirlFromHash() }
    : {};
  $.ajax({
    url: "/pageantvote/api/girls.php",
    type: "GET",
    data: query
  })
    .done(function (response) {
      //move response into global 'data' variable
      data = response;
      data.sort(() => Math.random() - 0.5);

      if (query.girl_id) {
        data.unshift(
          data.splice(
            data.findIndex(
              girl => girl.id === query.girl_id),
            1)[0]
        );
      }

      //Template out Hooters Girls
      utils.runTemplate("#hg-single", "#hg-gallery", data);
      utils.updateViewButton();
      utils.updateLoadMore(true);
      document.getElementById("hgApiResponse").dataset.girls = JSON.stringify(data);

      $("#hg-select")
        .fancySelect()
        .on("change.fs", function () {
          $(this).trigger("change.$");
        });

      $(".load-more").click(function (e) {
        e.preventDefault();
        utils.paginateGirls(e.pageY);
      });

      if (query.girl_id) {
        setTimeout(function () {
          $(".vote-now", $("#hg-gallery .hg-single:first-child")).trigger(
            "click"
          );
        }, 1000);
      }
    })
    .fail(function () {
      console.log("Failed to load data");
    });
}
function filterGirls(data, optionVal) {
  var filteredData = [];
  data.sort(compareByFirstName);

  if (optionVal === 'all') {
    filteredData = data;
  } else {
    data.map(girl => {
      var firstName = girl.first_name;
      var firstNames = [];
      var firstLetter = firstName.charAt(0);
      if (firstLetter.match(/[a-i]/i) && optionVal.match(/[a-i]/i)) {
        filteredData.push(girl);
      }
      if (firstLetter.match(/[j-r]/i) && optionVal.match(/[j-r]/i)) {
        filteredData.push(girl);
      }
      if (firstLetter.match(/[s-z]/i) && optionVal.match(/[s-z]/i)) {
        filteredData.push(girl);
      }
    })
  }

  utils.runTemplate("#hg-single", "#hg-gallery", filteredData);
  utils.updateViewButton();
  utils.updateLoadMore(true);
}
var loginPage = function() {
    $(".button--register-auth0").click(function () {
        window.location.href = "register";
    });

    $('#form-login-auth0').submit(function(){
        var obj = objectifyForm($( this ).serializeArray());
        var validate = obj['phone'].replace(/[- )(]/g,'');
        var dados = $( this ).serialize();

        $.ajax({
          type: "POST",
          url: "send-phone-number",
          data: dados,
          success: function( data ) {
            console.log('data')
              window.location.href = data;
          }
        });
        return false;
    });
};

var registerPage = function() {
  $("#state").fancySelect()
  $("#store").fancySelect()

    $.ajax({
        url: "/pageantvote/api/locations.php",
        type: "GET"
    })
        .done(function(response) {
            utils.runTemplate("#state-template", "#state", response);


            $("#state")
            .on("change.fs", function() {
                var state = $(this)[0].value;
                var locations = [];
                $(response).each(function(index, el) {
                    if (el.state == state) {
                        locations = el.locations;
                    }
                });
                utils.runTemplate("#store-template", "#store", locations);

                $("select").trigger("update.fs");
                $("#store").on("change.fs", function() {
                  $("button.submit-vote").removeAttr("disabled");
              });
            });
            $("select").trigger("update.fs");
        })
        .fail(function() {
            console.log("Failed to get locations. Check connection.");
    });

    $('.button--register-auth0').click(function(e){
        e.preventDefault();
        var validate = objectifyForm($('#form-register-auth0').serializeArray());
        var dados = $('#form-register-auth0').serialize();

        if(dados.indexOf('subscribe') === -1){
          dados += '&subscribe=false';
        }

        if(validate['first-name'] === "" || validate['last-name'] === "" || validate.email === "" || validate.phone === "" || validate.state === "" || validate.store === ""){
          $('.validate-terms').hide();
          $('.validate-form').show();
        }else if(!validate.terms){
          $('.validate-form').hide();
          $('.validate-terms').show();
        }else{
          $.ajax({
            type: "POST",
            url: "send-register",
            data: dados,
            success: function( data ) {
              window.location.href = data;
            }
          });
        }
        return false;
    });
};

function objectifyForm(formArray) {
  var returnArray = {};
  for (var i = 0; i < formArray.length; i++) {
    returnArray[formArray[i]['name']] = formArray[i]['value'];
  }
  return returnArray;
}

var validateCodePage = function() {
    $(".button--send-code-auth0").click(function (e) {
        $.ajax({
            type: "GET",
            url: "generate-new-code",
            success: function( data ) {
                window.location.href = data;
            }
        });
    });

    $('#form-confirm-code-auth0').submit(function(){
        var dados = $( this ).serialize();

        $.ajax({
            type: "POST",
            url: "confirm-code",
            data: dados,
            success: function( data ) {
                if(sessionStorage.hash){
                  window.location.href = data+sessionStorage.hash;
                }else{
                  window.location.href = data
                }
            }
        });

        return false;
    });
};

var ticketPage = function () {
  $("#terms").hide(0);
  $('[href="#terms"]').on("click", function (e) {
    e.preventDefault();
    if ($(this).hasClass("open")) {
      $("#terms").slideUp(250);
      $(this).removeClass("open");
    } else {
      $("#terms").slideDown(250);
      $(this).addClass("open");
    }
  });
};

//Share to Facebook and Twitter
//Update url and twitter copy per project
//The rest is pulled from meta tags
var share = (function () {
  var t = {};
  t.url = window.location.href;
  t.facebook = function () {
    var base_url = t.url + window.location.hash;
    var url =
      "https://www.facebook.com/sharer/sharer.php?u=" +
      encodeURIComponent(`${window.location.origin}${window.location.pathname}${window.location.hash}`);
    return url;
  };
  t.twitter = function () {
    var base_url = t.url + window.location.hash;
    var url =
      "https://twitter.com/intent/tweet?" +
      "url=" +
      encodeURIComponent(`${window.location.origin}${window.location.pathname}${window.location.hash}`) +
      "&text=" +
      encodeURIComponent(
        "Help choose this year’s Hooters Miss Fan Favorite! Cast your vote up to 5 times per day. The winner gets the title and $2,000! #HootersPageant"
      ) +
      "&source=webclient";
    return url;
  };
  t.open = function (url) {
    var h = 250;
    var w = 626;
    var wLeft = window.screenLeft ? window.screenLeft : window.screenX;
    var wTop = window.screenTop ? window.screenTop : window.screenY;

    var left = wLeft + window.innerWidth / 2 - w / 2;
    var top = wTop + window.innerHeight / 2 - h / 2;
    window.open(
      url,
      "Share",
      "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
      w +
      ", height=" +
      h +
      ", top=" +
      top +
      ", left=" +
      left
    );
  };
  t.init = function () {
    $("body").on("click", "a.facebook, a.twitter", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var url = t.facebook();
      var network = "Facebook";

      if ($(this).hasClass("twitter")) {
        url = t.twitter();
        network = "Twitter";
      }

      t.open(url);

      if ($(this).hasClass('hg-meta__share')) {
        var sharedGirl = $(this).data("share-girl");
        ga("send", "event", "share", network, sharedGirl);
      } else {
        ga("send", "event", network, "Share");
      }
    });
  };
  return t;
})();

jQuery(document).ready(function ($) {
  switch (doThis) {
    case "homePage":
      homePage();
      break;
    case "loginPage":
      loginPage();
      break;
    case "registerPage":
      registerPage();
      break;
    case "validateCodePage":
      validateCodePage();
      break;
    case "ticketPage":
      ticketPage();
      break;
    default:
      break;
  }

  share.init();
});

$(document).ready(function () {
  // Animated section jump
  $("#scroll-trigger").click(function () {
    var windowWidth = $(window).width();
    $("html, body").animate({ scrollTop: $("#scroll-to").offset().top }, 500);
  });
});

function compareByFirstName(a, b) {
  const locA = a.name;
  const locB = b.name;
  let comparison = 0;
  if (locA > locB) {
    comparison = 1;
  } else if (locA < locB) {
    comparison = -1;
  }
  return comparison;
}
var x, i, j, l, ll, selElmnt, a, b, c;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName("hg-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function (e) {
      /*when an item is clicked, update the original select box,
      and the selected item:*/
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function (e) {
    /*when the select box is clicked, close any other select boxes,
    and open/close the current select box:*/
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", closeAllSelect);